export function EnterKeyShortcutIcon() {
  return (
    <svg aria-hidden height={12} viewBox="0 0 13 10" width={16} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.11295 6.8L4.41122 8.96308C4.65252 9.19019 4.66403 9.56991 4.43692 9.81122C4.20981 10.0525 3.83009 10.064 3.58878 9.83692L0.188781 6.63692C0.0683093 6.52353 0 6.36544 0 6.2C0 6.03456 0.0683093 5.87646 0.188781 5.76308L3.58878 2.56308C3.83009 2.33597 4.20981 2.34748 4.43692 2.58878C4.66403 2.83008 4.65252 3.20981 4.41122 3.43692L2.11294 5.6L10.2 5.6C10.9732 5.6 11.6 4.9732 11.6 4.2V0.6C11.6 0.268629 11.8686 0 12.2 0C12.5314 0 12.8 0.268629 12.8 0.6V4.2C12.8 5.63594 11.6359 6.8 10.2 6.8L2.11295 6.8Z"
        fill="currentColor"
      />
    </svg>
  )
}
